import { EmployeePermissions } from "@snackpass/snackpass-types";

import { ErrorWithCause } from "src/utils/errors";
import { SnackpassPermissions } from "#settings/settings-permissions/types";

import { client } from "../client";

export type SendInviteBody = {
    email: string;
    jobTitle: string;
    /** Dashboard permissions, legacy flags as booleans. */
    permissions: Partial<SnackpassPermissions>;
    /** Does this person also get a register PIN? */
    deviceAccess: boolean;
    employeePermissions?: Partial<EmployeePermissions>;
    wage?: string;
    pin?: string;
    identifier?: string;
    /**
     * Promote an existing device-only team member: acceptance links this Employee instead
     * of creating one, so their PIN survives. The server ignores pin/wage/employeePermissions
     * when this is set.
     */
    employeeId?: string;
};

export class Admins {
    static async updateSelf(
        userId: string,
        update: {
            firstName?: string;
            lastName?: string;
            profilePicUrl?: string;
        },
    ) {
        const updates = {
            firstName: update.firstName,
            lastName: update.lastName,
            profilePicUrl: update.profilePicUrl,
        };
        return client
            .put(`/users/${userId}/update-self`, updates)
            .catch((cause) => {
                throw new ErrorWithCause(
                    `api.Admins.updateSelf: PUT to /users/${userId}/update-self failed`,
                    cause,
                );
            });
    }

    /** Dashboard access is granted by invite: the invitee proves they hold the address. */
    static async sendInvite(storeId: string, body: SendInviteBody) {
        return client
            .post("/admin-invite/create", {
                storeId,
                ...body,
                email: body.email.toLowerCase(),
            })
            .catch((cause) => {
                throw new ErrorWithCause(
                    "api.Admins.sendInvite: POST to /admin-invite/create failed",
                    cause,
                );
            });
    }
}
